import { useEffect, type JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import ReplayIcon from '@mui/icons-material/Replay';

import { routes } from '../../../routes';
import { useWozCaseManager } from '../woz-case-manager.provider';
import { WozCasePickerModal } from '../modals/WozCasePickerModal';

export const WozCaseManagerResumeCase = (): JSX.Element | null => {
  const { caseManagerState, caseManagerViewModel } = useWozCaseManager();
  const navigate = useNavigate();

  const { canResume, isCaseReady, isFlowComplete } = caseManagerState;

  useEffect(() => {
    if (isCaseReady) {
      caseManagerViewModel.setIsCaseReady(false);
      navigate(isFlowComplete ? routes.summary : routes.intake);
    }
  }, [isCaseReady, isFlowComplete, caseManagerViewModel, navigate]);

  if (!canResume) return null;

  return (
    <>
      <Button variant='outlined' startIcon={<ReplayIcon />} onClick={caseManagerViewModel.requestResume}>
        Hervatten
      </Button>
      <WozCasePickerModal
        open={caseManagerState.modals.showResumePicker}
        onClose={caseManagerViewModel.dismissResumePicker}
      />
    </>
  );
};
